import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    revenueTypes: [],
    totalRows: 0,
  },
  getters: {
    revenueTypes: state => state.revenueTypes,
    totalRows: state => state.totalRows,
  },
  mutations: {
    SET_REVENUETYPE: (state, { total, revenueTypes }) => {
      state.totalRows = total
      state.revenueTypes = revenueTypes
    },
  },
  actions: {
    async getRevenueTypes({ commit }, params) {
      try {
        const response = await axios.get('uni/revenueTypes', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, revenueTypes } = data.data
          commit('SET_REVENUETYPE', { total, revenueTypes })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createRevenueType({ commit }, params) {
      try {
        const response = await axios.post('uni/revenueTypes', params)
        const { data } = response
        const isSuccessful = data.code === ApiCode.SUCCESS
        if (isSuccessful) {
          return { isSuccessful, message: data.message }
        }
        return { isSuccessful, message: data.debugMessage }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateRevenueType({ commit }, params) {
      try {
        const response = await axios.put(`uni/revenueTypes/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteRevenueType({ commit }, id) {
      try {
        const response = await axios.delete(`uni/revenueTypes/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
